export default __webpack_public_path__ + "static/media/AI pic for SIP.e5e4e4c5.png";